import templateUrl from './company-add-form.html';

export default {
  templateUrl,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    company: '<',
    onCompanyChanged: '&'
  },
  controller: class CompanyAddFormComponent {
    constructor(EventEmitter) {
      'ngInject';

      Object.assign(this, { EventEmitter });
    }

    onSubmit() {
      this.onCompanyChanged(
        this.EventEmitter({
          company: this.company
        })
      );
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/admin/company/company-add-form/company-add-form.component.js